import { IPracticeState } from "@/store/modules/practice/types";

export const state: IPracticeState = {
  sections: [],
  section: null,
  questions: null,
  passages: null,
  completedSections: { ela: {}, math: {}, reading: {} },
};
